import { Carousel, Image } from '@belong/ui';
import clsx from 'clsx';
import { HoverStateProps, StepCard, StepCardConstantProps } from './step-card';
import css from './steps-section.module.css';

export type StepsSectionData = StepCardConstantProps & {
  hoverState?: HoverStateProps;
};

type StepsSectionProps = {
  data: StepsSectionData[];
  variant?: 'default' | 'medium' | 'small';
  showLines?: boolean; // render a curved line connecting the steps
  showNumbers?: boolean;
};

const stepsSlideClassName = 'flex justify-center min-w-full mb-sm';
const stepsRowClassName = 'xl:block xl:min-w-0 xl:mb-0 xl:mr-lg xl:last:mr-0';
const showLinesClassName = 'relative pt-2sm';

export function StepsSection({
  data,
  variant = 'default',
  showLines = false,
  showNumbers = true,
}: StepsSectionProps) {
  const stepCards = data.map((item, idx) => (
    <div
      className={clsx(stepsSlideClassName, stepsRowClassName, {
        [showLinesClassName]: showLines,
      })}
      key={idx}
    >
      <StepCard
        step={idx + 1}
        src={item.src}
        title={item.title}
        subtitle={item.subtitle}
        subtitleClassName={item.subtitleClassName}
        variant={variant}
        showNumbers={showNumbers}
        hoverState={
          item.hoverState && (
            <StepCard.HoverState
              title={item.hoverState.title}
              body={item.hoverState.body}
              action={item.hoverState.action}
              showNumbers={showNumbers}
            />
          )
        }
      />
      {showLines && idx < 2 && (
        <div className={clsx(css.line, 'xl:pl-lg absolute top-0')}>
          <Image src="homeowner-lp/ho_lp_line.svg" alt="" />
        </div>
      )}
    </div>
  ));

  return (
    <div className="flex w-full justify-center overflow-hidden">
      <div className="hidden xl:contents">{stepCards}</div>
      <div className="contents xl:hidden">
        <Carousel>{stepCards}</Carousel>
      </div>
    </div>
  );
}
